// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31eS0","content":"styles_content__1L0NM","row":"styles_row__3-bqA","footer":"styles_footer__gl5Gv","phraseLength":"styles_phraseLength__3DgG-"};